export default function ToggleNav({ isOpen, handleOpen }) {
   return(
      <button className="nav-toggle" aria-expanded={isOpen} onClick={handleOpen}>
         <span className="bar1" />
         <span className="bar2" />
         <span className="bar3" />
      </button>
   );
}